import MUIDrawer, { DrawerProps } from "@mui/material/Drawer";
import React, { FC } from "react";

export const Drawer: FC<DrawerProps> = (props) => (
  <MUIDrawer {...props} />
);
